/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QueryTimeRangeUtc
 */
export interface QueryTimeRangeUtc {
    /**
     * 
     * @type {string}
     * @memberof QueryTimeRangeUtc
     */
    startInclusive?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryTimeRangeUtc
     */
    endInclusive?: string;
}

/**
 * Check if a given object implements the QueryTimeRangeUtc interface.
 */
export function instanceOfQueryTimeRangeUtc(value: object): value is QueryTimeRangeUtc {
    return true;
}

export function QueryTimeRangeUtcFromJSON(json: any): QueryTimeRangeUtc {
    return QueryTimeRangeUtcFromJSONTyped(json, false);
}

export function QueryTimeRangeUtcFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryTimeRangeUtc {
    if (json == null) {
        return json;
    }
    return {
        
        'startInclusive': json['startInclusive'] == null ? undefined : json['startInclusive'],
        'endInclusive': json['endInclusive'] == null ? undefined : json['endInclusive'],
    };
}

export function QueryTimeRangeUtcToJSON(json: any): QueryTimeRangeUtc {
    return QueryTimeRangeUtcToJSONTyped(json, false);
}

export function QueryTimeRangeUtcToJSONTyped(value?: QueryTimeRangeUtc | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startInclusive': value['startInclusive'],
        'endInclusive': value['endInclusive'],
    };
}

